class Certificate {
  import(type, data) {
    return Munio.$http.post('certificate_import', `/api/munio/certificate/import/${type}`, data)
  }
}

export default Certificate
